import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-news-section-dialog',
  templateUrl: 'dialog.component.html',
})
export class NewsSectionDialogComponent implements OnInit {

  loading: boolean;
  sections: string;

  constructor(
    public dialogRef: MatDialogRef<NewsSectionDialogComponent>,
    public dataService: DataService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getSections();
  }

  getSections() {
    this.dataService.newsSection()
      .subscribe((response: any) => {
        this.loading = false;
        this.sections = response.data;
      });
  }

  selectSession(session: any) {
    this.dialogRef.close(session);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
